import {
  Box,
  InputBase,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  styled,
} from "@mui/material";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";
import useQuery from "utils/router.util";

const tabs = [
  {
    key: "all",
    label: "All",
  },
  {
    key: "tractor",
    label: "Tractor",
  },
  {
    key: "attachment",
    label: "Attachment",
  },
];

const StyledTabs = styled((props: any) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  overflow: "auto",
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    height: "4px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "#6E8C20",
    height: "4px",
  },
});

const StyledTab = styled((props: any) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    display: "flex",
    textTransform: "none",
    fontWeight: 500,
    fontSize: "15px",
    marginRight: theme.spacing(3),
    // minHeight: "60px",
    // padding: "10px 0px",
    "& svg path": {
      stroke: "#323232",
    },
    color: "#323232",
    "&.Mui-selected": {
      color: "#6E8C20",
      fontWeight: 600,

      "& svg path": {
        stroke: "#6E8C20",
      },
    },
    "&.Mui-focusVisible": {
      backgroundColor: "rgba(100, 95, 228, 0.32)",
    },
  })
);

const ListingTypes = ({ selection = false }: { selection?: Boolean }) => {
  const query = useQuery();
  const tab = query.get("type") || "all";
  const navigate = useNavigate();
  if (selection) {
    return (
      <Box>
        <Select
          input={
            <InputBase
              placeholder="By Horse Power"
              sx={{
                border: "1px solid #E2E2E2",
                height: "33px",
                borderRadius: "10px",

                pl: "20px",
              }}
            />
          }
          value={tab}
          onChange={(v: any) =>
            navigate(`${ROUTES.LISTING}?type=${v.target.value}`)
          }
        >
          {tabs.map((t: any) => (
            <MenuItem value={t.key}>{t.label}</MenuItem>
          ))}
        </Select>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor: "background.paper",
        borderBottom: "1px solid #F4F4F4",

        px: "3%",
      }}
    >
      <StyledTabs
        value={tab}
        sx={{
          px: "1%",
        }}
        onChange={(_: any, v: any) => navigate(`${ROUTES.LISTING}?type=${v}`)}
        TabIndicatorProps={{
          style: { transition: "none" },
        }}
      >
        {tabs.map((t: any, i: number) => (
          <StyledTab label={t.label} value={t.key} />
        ))}
      </StyledTabs>
    </Box>
  );
};

export default ListingTypes;
